import {
    FETCH_DISCIPLINE_LIST_REQUEST,
    FETCH_DISCIPLINE_LIST_SUCCESS,
    FETCH_DISCIPLINE_LIST_FAILURE,
  } from "./FetchDisciplineListTypes";
  
  const initialState = {
    loading: false,
    disciplineList: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_DISCIPLINE_LIST_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_DISCIPLINE_LIST_SUCCESS:
        return {
          loading: false,
          disciplineList: action.payload,
          error: "",
        };
      case FETCH_DISCIPLINE_LIST_FAILURE:
        return {
          loading: false,
          disciplineList: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  